// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"67e68238","41":"a140ff32","180":"1ec130b8","191":"698c8f0f","202":"c48658ef","581":"5ca58a8c","615":"821a9e9b","755":"3ee5ff9a","846":"b0942561","984":"6bffafe1"}[chunkId] + ".chunk.js";
};